import { apiRequest, roughCreate } from "../../../../services/adapters/base";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      roughCreate,
      {
        body: query,
      },
      true
    );
  };
}

export default CreateRepository;
